import { render, staticRenderFns } from "./folders-vessels-option-owners.vue?vue&type=template&id=2551aade&scoped=true"
import script from "./folders-vessels-option-owners.vue?vue&type=script&lang=js"
export * from "./folders-vessels-option-owners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2551aade",
  null
  
)

export default component.exports